// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgTemperatureIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M12 13.02V5c0-1.66-1.34-3-3-3S6 3.34 6 5v8.02c-1.21.91-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98M9 20c-1.66 0-3-1.34-3-3 0-1.3.84-2.4 2-2.82V9c0-.55.45-1 1-1s1 .45 1 1v5.18A2.996 2.996 0 0 1 9 20m6-16c0-.55.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3c-.55 0-1-.45-1-1m5 4c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1m0 4c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1" />
  </g>
);
export default SvgTemperatureIcon;
SvgTemperatureIcon.displayName = 'SvgTemperatureIcon';
